<template>
  <div class="mobile-container">
    <page-header>{{'会议议程' | dealLanguage('Conference Agenda')}}</page-header>
    <div class="filter-tag">
      <div class="filter-tag-item" v-for="item in assort_list" :key="index + 'assort'" :class="{'filter-tag-active' : item == active_assort}" @click="changeAssort(item)">
        {{item}}
      </div>
    </div>
    <div class="filter-tag">
      <div class="filter-tag-item" v-for="item in date_list" :key="index + 'date'" :class="{'filter-tag-active' : item == active_date}" @click="changeDate(item)">
        {{item}}
      </div>
    </div>
    <van-tabs ref="van-tabs" v-model="activeId" scrollspy sticky title-inactive-color="#999" title-active-color="#333" offset-top="1.22rem">
      <van-tab v-for="item in froum_list" :title="item.activityName | dealLanguage(item.enActivityName)" :key="item.activityId" :name="item.activityId">
        <div class="froum-wrapper">
          <div class="froum-base">
            <p>{{item.dateName}}-{{item.activityName | dealLanguage(item.enActivityName)}}</p>
            <p class="p2" v-if="language == 'zh' && item.leadPerson">牵头人：{{item.leadPerson}}</p>
            <p class="p2" v-if="language != 'zh' && item.enLeadPerson">LeadPerson:{{item.enLeadPerson}}</p>
            <p class="location" v-if="item.forumPlace"><i class="iconfont">&#xe672;</i>{{item.forumPlace}}</p>
          </div>
          <div class="agenda-item" v-for="(aitem, gindex) in item.agendas" :key="gindex">
            <div class="forum-title">
              <span class="time">{{aitem.agendaStartTime | time_moment('HH:mm')}}</span>
              <span class="title">{{aitem.agendaTitle | dealLanguage(aitem.enAgendaTitle)}}</span>
            </div>
            <div class="froum-speakers">
              <div class="froum-speakers-item" v-for="(gitem, gindex) in aitem.guests" :key="gindex" @click="goDetail(gitem.id)">
                <div class="speaker-img">
                  <div class="photo">
                    <img :src="gitem.logoUrl | logo_show" />
                  </div>
                  <!-- <div class="logo">
                    <img src="https://cdn.vbdata.cn/upload/entity/98e1dc77838bd21fe216a95ffb30e17084.PNG" />
                  </div> -->
                </div>
                <div class="speaker-info">
                  <div class="speaker-name" @click="goGuestDetail(gitem.id)">
                    <span></span>
                    {{gitem.name | dealLanguage(gitem.enName)}}
                  </div>
                  <div class="speaker-title" v-html="filter.dealLanguage(gitem.companyPosition, gitem.enCompanyPosition)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import { getAgendaList } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '会议议程' : 'Meeting agenda',
    }
  },
  inject: ['globalInsertRecords', 'wxShare'],
  data() {
    return {
      filter,
      froum_list: [],
      assort_list: [filter.dealLanguage('全部分类', 'All meetings')],
      date_list: [filter.dealLanguage('全部时间', 'All time')],
      first_load: 0,
      active_assort: filter.dealLanguage('全部分类', 'All meetings'),
      active_date: filter.dealLanguage('全部时间', 'All time'),
      anchor_list: [],
      activeId: '',
    }
  },

  components: {
    PageHeader,
  },

  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
      vbef_path: (state) => state.vbef_path,
      static_img_url: (state) => state.static_img_url,
    }),
  },

  created() {
    this.getAgendaList()
  },

  mounted() {
    this.wxShare({
      title: filter.dealLanguage('会议议程-CSGCT', 'Meeting agenda-CSGCT'),
      linkurl: this.vbef_path + '/agenda',
    })
  },

  methods: {
    goGuestDetail(guest_id) {
      this.globalInsertRecords({
        contentId: guest_id,
        contentType: 152,
        viewType: 1,
      })
      this.$router.push({
        name: 'guestInfo',
        params: {
          id: guest_id,
        },
      })
    },
    changeAssort(item) {
      this.active_assort = item
      this.getAgendaList()
    },
    changeDate(item) {
      this.active_date = item
      this.getAgendaList()
    },
    goDetail(id) {
      this.$router.push({
        name: 'guestInfo',
        params: {
          id: id,
        },
      })
    },
    async getAgendaList() {
      let res = await getAgendaList({
        actId: this.activityId,
        assortName:
          this.active_assort == '全部分类' || this.active_assort == 'All meetings'
            ? ''
            : this.active_assort,
        dateName:
          this.active_date == '全部时间' || this.active_date == 'All time' ? '' : this.active_date,
      })
      if (res.code == 0) {
        this.$set(this.$data, 'froum_list', res.data.activities)
        this.activeId =
          this.$route.query.id || (this.froum_list.length ? this.froum_list[0].activityId : '')
        if(this.$route.query.id) {
          this.$nextTick(() => {
            this.$refs['van-tabs'].scrollTo(this.$route.query.id)
          })
        }
        this.froum_list.map((a) => {
          let len = this.froum_list.filter((item) => item.activityId == a.activityId).length
          let anchor_name = len > 1 ? `${a.activityName}（${a.dateName}）` : a.activityName
          let en_anchor_name = len > 1 ? `${a.enActivityName}（${a.dateName}）` : a.enActivityName
          this.anchor_list.push({
            id: a.activityId,
            name: anchor_name,
            en_name: en_anchor_name,
          })
          if (a.forumPlaceJson) {
            let place = JSON.parse(a.forumPlaceJson)
            let forum = ''
            if (place.level1_show == 1 && place.place_level1) forum += place.place_level1
            if (place.level2_show == 1 && place.place_level2) forum += ' ' + place.place_level2
            if (place.level3_show == 1 && place.place_level3) forum += ' ' + place.place_level3
            this.$set(a, 'forumPlace', forum)
          } else {
            this.$set(a, 'forumPlace', '')
          }
        })
        if (this.first_load == 0) {
          this.assort_list = [...this.assort_list, ...res.data.assortNames]
          this.date_list = [...this.date_list, ...res.data.dateNames]
        }
        this.first_load = 1
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.mobile-container
  >>>.main-header
    margin-bottom 0.2rem
  >>>.van-sticky
    box-shadow 0 0.04rem 0.1rem 0 rgba(0, 0, 0, 0.1)
  >>>.van-tabs__nav--line
    padding 0 0.4rem
    .van-tab
      margin-right 0.28rem
      padding-bottom 0.12rem
      &.van-tab--active
        position relative
        &::before
          content ''
          position absolute
          bottom 0.17rem
          width 100%
          border-bottom 0.02rem solid #c8161d
    .van-tabs__line
      width 0
      height 0
  .filter-tag
    padding 0 0.4rem 0.2rem
    display flex
    flex-wrap wrap
    &-item
      flex 0 0 1.6rem
      height 0.6rem
      border 1px solid #C8161D
      display flex
      justify-content center
      align-items center
      font-size 0.24rem
      color #C8161D
      margin-bottom 0.1rem
      &:not(:nth-of-type(4n))
        margin-right calc(((100% - 6.4rem) / 3))
    &-active
      background #C8161D
      color #fff
.froum-wrapper
  .froum-base
    background #80A4FF
    padding 0.2rem 0.4rem
    font-size 0.28rem
    color #FFFFFF
    position relative
  .agenda-item
    padding 0.2rem 0 0
    margin 0 0.4rem
    border-bottom 0.01rem solid #eee
    .forum-title
      .time
        font-size 0.26rem
        color #c8161d
        line-height 0.36rem
        margin-right 0.3rem
      .title
        font-size 0.26rem
        color #333333
        line-height 0.36rem
    .froum-speakers
      padding 0.2rem 0.4rem 0.13rem
      display flex
      justify-content space-between
      flex-wrap wrap
      &-item
        height 1rem
        flex 0 0 48%
        display flex
        margin-bottom 0.4rem
        .speaker-img
          height 1rem
          width 1rem
          position relative
          .photo
            width 1rem
            height 1rem
            img
              height 100%
              max-width 100%
          .logo
            width 0.4rem
            height 0.4rem
            background #FFFFFF
            box-shadow 0px 0.03rem 0.08rem 0px rgba(0, 0, 0, 0.16)
            display flex
            align-items center
            justify-content center
            position absolute
            bottom -0.2rem
            right -0.2rem
            img
              max-width 100%
              max-height 100%
        .speaker-info
          padding-left 0.1rem
          .speaker-name
            span
              display inline-block
              width 0.02rem
              height 0.24rem
              background #c8161d
              margin-right 0.06rem
              font-size 0.24rem
              color #333333
          .speaker-title
            font-size 0.22rem
            color #666666
            margin-top 0.09rem
            display -webkit-box
            overflow hidden
            text-overflow ellipsis
            word-break break-all
            -webkit-box-orient vertical
            -webkit-line-clamp 2
</style>